module.exports = __webpack_public_path__ + "img/What_are_your_numbers.37571390.png";